import { Center, type CenterProps } from '@chakra-ui/react';

export type UiCenterProps = CenterProps;

export const UiCenter = Center;
